/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
/* eslint-disable react/no-danger */

import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@userzoomlibraries/toolkit-button';
import StudyLayout, { useDevice } from '@userzoomplatform/pe-study-layout';

import { usePageView } from '../../../../hooks';
import { Namespaces } from '../../../../utils/i18n';
import { closeIframe } from '../../../../utils/post-messages';
import { inIframe } from '../../../../utils/iframe';

type Props = {
	moveNext?: () => void;
	content: string;
	className?: string;
};

const defaultProps = {
	moveNext: () => null,
	className: '',
};

const WelcomePage = ({ moveNext, content, className }: Props): ReactElement => {
	const { t } = useTranslation(Namespaces.Common);
	const { device } = useDevice();
	usePageView('/welcome-page');

	return (
		<StudyLayout className={className} device={device}>
			<StudyLayout.Header exitText={inIframe ? t(`${Namespaces.Common}:cta.quit`) : ''} onExitClick={closeIframe} />
			<StudyLayout.Content>
				<div dangerouslySetInnerHTML={{ __html: content }} />
			</StudyLayout.Content>
			<StudyLayout.Footer>
				<Button onClick={moveNext}>{t(`${Namespaces.Common}:cta.startStudy`)}</Button>
			</StudyLayout.Footer>
			{!inIframe && <StudyLayout.FooterText />}
		</StudyLayout>
	);
};

WelcomePage.defaultProps = defaultProps;

export default WelcomePage;
